export type Color = "MainColorGreen" | "HeaderBackGround" | "CharacterBlack" | "Gray" | "ReservationNotCompletedGray" | "RequiredRed" | "ErrorColor";

export const ColorHexCodes = {
  MainColorGreen: "84a154",
  HeaderBackGround: "efede6",
  CharacterBlack: "242424",
  Gray: "9f9f9f",
  ReservationNotCompletedGray: "cacaca",
  RequiredRed: "e84a43",
  ErrorColor: "ffd3da",
  Blue: "0000FF"
};
